(function () {
  // Product PDP scroll unlock — FB in-app / third-party overlays often set overflow:hidden
  var isProduct =
    (location.pathname || '').indexOf('/products/') === 0 ||
    !!document.querySelector('[data-template="product"]');
  if (!isProduct) return;

  function unlock() {
    if (document.documentElement.classList.contains('gz-popup-lock')) return;
    // GZ 2026-10-08: theme modals (cart drawer, quick add, search) lock scroll via body{position:fixed};
    // undoing that made the page jump to the top and scroll behind the open cart drawer.
    if (document.querySelector('dialog[open]')) return;
    var html = document.documentElement;
    var body = document.body;
    if (!body) return;
    if (html.style.overflow === 'hidden') html.style.overflow = '';
    if (body.style.overflow === 'hidden') body.style.overflow = '';
    if (html.style.position === 'fixed') {
      html.style.position = '';
      html.style.top = '';
      html.style.width = '';
    }
    if (body.style.position === 'fixed') {
      var top = body.style.top;
      body.style.position = '';
      body.style.top = '';
      body.style.width = '';
      body.style.left = '';
      body.style.right = '';
      if (top) {
        var y = Math.abs(parseInt(top, 10) || 0);
        if (y) window.scrollTo(0, y);
      }
    }
  }

  unlock();
  setInterval(unlock, 1200);
  document.addEventListener('touchstart', unlock, { passive: true, capture: true });
  document.addEventListener('touchmove', function () {
    unlock();
  }, { passive: true, capture: true });

  try {
    var mo = new MutationObserver(function () { unlock(); });
    mo.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style', 'class'],
      subtree: false
    });
    if (document.body) {
      mo.observe(document.body, {
        attributes: true,
        attributeFilter: ['style', 'class'],
        childList: true,
        subtree: true
      });
    }
  } catch (e) {}
})();
